import PaletteOutlined from '@mui/icons-material/PaletteOutlined';
import { Box, Typography } from '@/shared/ui';

import ApplyPaletteDropdown from '@/features/dashboard/components/AppForm/AppForm/components/ColorPaletteSelector/ApplyPaletteDropdown';
import ColorSelectionList from '@/features/dashboard/components/AppForm/AppForm/components/ColorPaletteSelector/ColorSelectionList';
import { EmptyState } from '@/features/dashboard/components/AppForm/AppForm/components/EmptyState';
import { useAppForm } from '@/features/dashboard/components/AppForm/AppForm/context';

const ColorPaletteSelector = () => {
  const { form } = useAppForm();

  return (
    <form.Subscribe selector={s => s.values?.symbols}>
      {symbols => (
        <Box
          sx={{
            backgroundColor: 'gx.tileDark',
            display: 'flex',
            flexDirection: 'column',
            p: 2
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              mb: 3
            }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Typography sx={{ fontWeight: 700, fontSize: 14, mb: 1 }}>Color selection</Typography>
              <Typography sx={{ fontWeight: 500, fontSize: 12, color: 'gx.textDisabled' }}>
                Choose a palette to customize the colors for each line in your chart
              </Typography>
            </Box>
            <ApplyPaletteDropdown />
          </Box>
          {symbols && symbols.active.length > 0 && <ColorSelectionList />}
          {(!symbols || symbols.active.length === 0) && (
            <EmptyState
              description='Select items above to configure their chart palette'
              icon={<PaletteOutlined />}
              title='No colors to configure'
            />
          )}
        </Box>
      )}
    </form.Subscribe>
  );
};

export default ColorPaletteSelector;
